import { List, Map } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

export class RefundsV2Store extends BaseStore {

    getInitialState () {
        return new Map({
            draft: null,
            draftPending: false,
            draftErrors: new List(),
            draftRequestId: 0,
            draftSelectionKey: null
        });
    }

    handleDraftStarted ({ requestId, selectionKey }) {
        this.setState(this.state.merge({
            draft: null,
            draftPending: true,
            draftErrors: new List(),
            draftRequestId: requestId,
            draftSelectionKey: selectionKey
        }));
    }

    _isStale (requestId) {
        return requestId !== this.state.get('draftRequestId');
    }

    handleDraftLoaded ({ draft, requestId }) {
        if (this._isStale(requestId)) {
            return;
        }

        this.setState(this.state.merge({
            draft,
            draftPending: false,
            draftErrors: new List()
        }));
    }

    handleDraftFailed ({ errors, requestId }) {
        if (this._isStale(requestId)) {
            return;
        }

        this.setState(this.state.merge({
            draft: null,
            draftPending: false,
            draftErrors: errors || new List()
        }));
    }

    getActionHandlers () {
        return {
            [ActionTypes.REFUND_DRAFT_STARTED]: this.handleDraftStarted,
            [ActionTypes.REFUND_DRAFT_LOADED]: this.handleDraftLoaded,
            [ActionTypes.REFUND_DRAFT_FAILED]: this.handleDraftFailed,
            [ActionTypes.REFUND_V2_RESET]: this.resetState,
            [ActionTypes.REFUND_RESET]: this.resetState
        };
    }
}

const instance = new RefundsV2Store();

export default instance;
